<template>
  <div class="customizedService">
    <div class="wrapper">
      <div class="customizedServiceTitle">
        {{text}}<span class="colorStyle">{{colorText}}</span>
      </div>
      <div class="customizedServiceCon">
        <div class="from">
          <div class="from_item">
            <input class="inputStyle" v-model="partner" placeholder="姓名/公司名称" />
            <input class="inputStyle" v-model="contactDetails" placeholder="手机/微信" />
          </div>
          <div class="from_item">
            <textarea class="textStyle" v-model="message" placeholder="合作意向"></textarea>
          </div>
          <div class="disflex">
            <button class="btnStyle" @click="customizationFn">立即定制</button>
            <button v-if="metaTitle == '医疗供给端'" class="btnStyle btn2" @click="goPage">立即入驻</button>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    text:{
      type: String,
      default:''
    },
    colorText:{
      type: String,
      default: ''
    }
  },
  data(){
    return {
      partner: '',  //姓名、公司名称
      contactDetails: '',  //手机/微信
      message: '',   //合作意向
      metaTitle: ''
    }
  },
  created(){
    this.metaTitle = this.$router.history.current.meta.title
  },
  methods: {
    customizationFn(){
      if(!this.partner || !this.contactDetails || !this.message) {
        alert('请填写信息')
        return
      }
      axios.post('https://ums.youjiajk.com/homeControl/put/message',{
        partner:this.partner,
        contactDetails:this.contactDetails,
        message:this.message
      }).then(res=>{
        console.log(res)
        if(res.data.code === 0) {
           alert('提交成功');
           this.partner = ''
           this.contactDetails = ''
           this.message = ''
        } else {
          alert('提交失败')
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    goPage(){
      let href = 'https://drugsupplier.youjiajk.com/#/register'
      window.open(href,'_blank')
    }
  }
}
</script>

<style lang="less">
  .el-message .el-icon-warning{
    font-size:20px;
  }
</style>

<style lang="less" scoped>
  .customizedService{
    background: url(../assets/image/made.png) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    // height: 475px;
    .wrapper{
      width:1200px;
      margin: 0 auto;
      .customizedServiceTitle{
        font-size:40px;
        font-weight: 300;
        color: #333333;
        text-align: center;
        margin-bottom: 30px;
        padding-top: 140px;
        .colorStyle{
          color: #FD8246;
        }
      }
      .customizedServiceCon{
        padding-bottom: 140px;
        .from{
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          align-items: center;
          width:640px;
          margin: 0 auto;
          .from_item{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            .inputStyle{
              width: 310px;
              border: none;
              height: 40px;
              text-indent: 10px;
              outline: none;
              &:first-child{
                margin-right: 10px;
              }
            }
            .textStyle{
              width: 100%;
              border: none;
              padding-top: 10px;
              height: 150px;
              text-indent: 10px;
              margin-top: 20px;
              outline: none;
            }
          }
          .disflex{
            display: flex;
            align-items: center;
          }
          .btnStyle{
            width: 200px;
            height: 40px;
            line-height: 24px;
            display: block;
            background: #fd8246;
            border-radius: 4px;
            color:#ffffff;
            margin-top:20px;
            border: none;
            outline: medium;
            cursor: pointer;
          }
          .btn2{
            width: 160px;
            margin-left: 20px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/customizedServicePc.vue